import "./Container.css";
import cn from "classnames";
import type { ComponentProps, FC } from "react";

export const Container: FC<ComponentProps<"div">> = (props) => {
  const { className, ...rest } = props;

  return <div className={cn("container", className)} {...rest} />;
};
